module.exports = __webpack_public_path__ + "static/tools_mark-ff6bbfc2ac386041c4505c0d26fdf811.png";